/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $PreRegisterDenyRequest = {
  properties: {
    denyType: {
      type: 'RegisterDenyType',
      isRequired: true,
    },
    professionalId: {
      type: 'string',
      isRequired: true,
    },
    reason: {
      type: 'string',
      isRequired: true,
    },
    document: {
      type: 'File',
    },
  },
} as const;
